import React, { useEffect } from 'react';
import Paper from '@material-ui/core/Paper';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { Typography } from '@material-ui/core';
import { getTheme } from '../../../../theme';

const ThematicPackageSelection = (props) => {
  useEffect(() => {
    // reset option on mount
    props.onChange(undefined, undefined);
  }, []);

  return (
    <>
      <Typography align='center' variant='h5'>
        Choose one of the available thematic packages
      </Typography>
      <Paper style={ { padding: getTheme().spacing(4), margin: getTheme().spacing(3) } }>
        <Autocomplete
          style={ { width: 350 } }
          limitTags={ 1 }
          options={ props.options }
          getOptionLabel={ (option) => {
            return option.name;
          } }
          onChange={ (event, newValue) => {
            props.onChange(event, newValue);
          } }
          value={ props.value }
          renderInput={ (params) => {
            return (
              <TextField
                { ...params }
                label={ `${ props.options.length } Options` }
                variant='outlined'
                placeholder='Thematic Packages'
              />
            );
          } }
        />

      </Paper>
    </>
  );
};

export default ThematicPackageSelection;
